import { create } from 'zustand'

export interface Toast {
  id: string
  type: 'success' | 'error' | 'info' | 'warning'
  message: string
  // EP-156 (T156-010) — an optional in-toast link, e.g. "[View]" pointing
  // at a record the action just created (the lease-end move_in_refund
  // Expense). Additive; every existing caller is unaffected.
  action?: { label: string; to: string }
}

interface NotificationState {
  unreadCount: number
  toasts: Toast[]
  setUnreadCount: (count: number) => void
  addToast: (toast: Omit<Toast, 'id'>) => void
  removeToast: (id: string) => void
}

export const useNotificationStore = create<NotificationState>()((set) => ({
  unreadCount: 0,
  toasts: [],
  setUnreadCount: (count) => set({ unreadCount: count }),
  addToast: (toast) =>
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id: crypto.randomUUID() }],
    })),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))
